import { useRef } from "react";
const EMPTY_VALUE = Symbol("useLazyRef empty value");
const useLazyRef = (init) => {
  const resultRef = useRef(EMPTY_VALUE);
  if (resultRef.current === EMPTY_VALUE) {
    resultRef.current = init();
  }
  return resultRef;
};
export {
  EMPTY_VALUE,
  useLazyRef
};
